import { queryOptions } from '@tanstack/react-query';

import { getVintage, getVintageProducts, getVintageStores, getVintagesListing } from './api';

export const vintageQueryKeys = {
	all: ['vintages'],
	listing: ['vintages', 'listing'],
	vintage: (vintageId: number) => ['vintages', vintageId],
	stores: (vintageId: number) => ['vintages', vintageId, 'stores'],
	products: (vintageId: number) => ['vintages', vintageId, 'products'],
} as const;

export const vintageQueries = {
	listing: queryOptions({
		queryKey: vintageQueryKeys.listing,
		queryFn: () => getVintagesListing(),
		initialData: [],
		initialDataUpdatedAt: 0,
	}),
	vintage: (vintageId: number) =>
		queryOptions({
			queryKey: vintageQueryKeys.vintage(vintageId),
			queryFn: () => getVintage(vintageId),
		}),
	stores: (vintageId: number) =>
		queryOptions({
			queryKey: vintageQueryKeys.stores(vintageId),
			queryFn: () => getVintageStores(vintageId),
		}),
	products: (vintageId: number) =>
		queryOptions({
			queryKey: vintageQueryKeys.products(vintageId),
			queryFn: () => getVintageProducts(vintageId),
		}),
} as const;
